import {TestimonialDataItem} from './shared/types/testimonial.types';
import {ChipType} from './shared/components/chip/types';

const AVATAR_SETS = {
    FULL_SET: [
        {
            url: 'https://frontends.udemycdn.com/frontends-landing-pages/60-day-hustle/images/social-proof/G1_1.png',
        },
        {
            url: 'https://frontends.udemycdn.com/frontends-landing-pages/60-day-hustle/images/social-proof/G1_2.png',
        },
        {
            url: 'https://frontends.udemycdn.com/frontends-landing-pages/60-day-hustle/images/social-proof/G1_3.png',
        },
        {
            url: 'https://frontends.udemycdn.com/frontends-landing-pages/60-day-hustle/images/social-proof/G1_4.png',
        },
        {
            url: 'https://frontends.udemycdn.com/frontends-landing-pages/60-day-hustle/images/social-proof/G1_5.png',
        },
        {
            url: 'https://frontends.udemycdn.com/frontends-landing-pages/60-day-hustle/images/social-proof/G1_6.png',
        },
        {
            url: 'https://frontends.udemycdn.com/frontends-landing-pages/60-day-hustle/images/social-proof/G1_7.png',
        },
    ],
    PARTIAL_SET: [
        {
            url: 'https://frontends.udemycdn.com/frontends-landing-pages/60-day-hustle/images/social-proof/G2_1.png',
        },
        {
            url: 'https://frontends.udemycdn.com/frontends-landing-pages/60-day-hustle/images/social-proof/G2_2.png',
        },
        {
            url: 'https://frontends.udemycdn.com/frontends-landing-pages/60-day-hustle/images/social-proof/G2_3.png',
        },
        {
            url: 'https://frontends.udemycdn.com/frontends-landing-pages/60-day-hustle/images/social-proof/G2_4.png',
        },
        {
            url: 'https://frontends.udemycdn.com/frontends-landing-pages/60-day-hustle/images/social-proof/G2_5.png',
        },
        {
            url: 'https://frontends.udemycdn.com/frontends-landing-pages/60-day-hustle/images/social-proof/G2_6.png',
        },
    ],
};

export const SocialProofData: TestimonialDataItem[] = [
    {
        type: 'video',
        variant: 'full',
        media: {
            url: '/60-day-hustle/videos/60-day-hustle-sp1-v2.mp4',
            alt: 'Video testimonial from Cheyenne Brown',
        },
    },
    {
        type: 'media',
        variant: 'full',
        media: {
            url: 'https://frontends.udemycdn.com/frontends-landing-pages/60-day-hustle/images/social-proof/60-day-hustle-sp-1.png',
            alt: 'Person 1',
        },
    },
    {
        type: 'testimonial',
        variant: 'split',
        layout: {
            position: 'top',
            flexDirection: 'column',
        },
        avatars: AVATAR_SETS.FULL_SET,
        testimonial: {
            quote: '"You don\'t have to figure out everything alone. With Udemy, I got everything I need, right where I need it."',
            author: {
                name: 'Cheyenne\nBrown',
                avatar: {
                    url: 'https://frontends.udemycdn.com/frontends-landing-pages/60-day-hustle/images/social-proof/G2_7.png',
                    alt: 'Cheyenne Brown',
                },
            },
        },
    },
    {
        type: 'video',
        variant: 'full',
        media: {
            url: '/60-day-hustle/videos/60-day-hustle-sp2-v2.mp4',
            alt: 'Video testimonial from Cheyenne Brown',
        },
    },
    {
        type: 'media',
        variant: 'full',
        media: {
            url: 'https://frontends.udemycdn.com/frontends-landing-pages/60-day-hustle/images/social-proof/60-day-hustle-sp-2.png',
            alt: 'Person 1',
        },
    },
    {
        type: 'testimonial',
        variant: 'full',
        testimonial: {
            quote: '"The experts on Udemy make it really easy to understand. They break it down really well and teach you a lot of things you can use to harness the power of AI." ',
            author: {
                name: 'Joseph\nKemp',
                avatar: {
                    url: 'https://frontends.udemycdn.com/frontends-landing-pages/60-day-hustle/images/social-proof/G1_6.png',
                    alt: 'Joseph Kemp',
                },
            },
        },
    },
    {
        type: 'video',
        variant: 'full',
        media: {
            url: '/60-day-hustle/videos/60-day-hustle-sp3-v2.mp4',
            alt: 'Video testimonial from Cheyenne Brown',
        },
    },
    {
        type: 'testimonial',
        variant: 'split',
        layout: {
            position: 'bottom',
            flexDirection: 'column-reverse',
        },
        avatars: AVATAR_SETS.PARTIAL_SET,
        testimonial: {
            quote: '"Now when it comes to my business, I don\'t have to guess anymore. I know exactly where to go to access information."',
            author: {
                name: 'Cheyenne\nBrown',
                avatar: {
                    url: 'https://frontends.udemycdn.com/frontends-landing-pages/60-day-hustle/images/social-proof/G2_7.png',
                    alt: 'Cheyenne Brown',
                },
            },
        },
    },
    {
        type: 'media',
        variant: 'full',
        media: {
            url: 'https://frontends.udemycdn.com/frontends-landing-pages/60-day-hustle/images/social-proof/60-day-hustle-sp-3.png',
            alt: 'Person 1',
        },
    },
];

export const SocialProofMobileData: TestimonialDataItem[] = [
    {
        type: 'video',
        variant: 'full',
        media: {
            url: '/60-day-hustle/videos/60-day-hustle-sp3-v2.mp4',
            alt: 'Video testimonial from Cheyenne Brown',
        },
        chipType: ChipType.PITCHING,
        chipTypeBottom: ChipType.BRAND_EXPERIENCE,
    },
    {
        type: 'media',
        variant: 'full',
        media: {
            url: 'https://frontends.udemycdn.com/frontends-landing-pages/60-day-hustle/images/social-proof/60-day-hustle-sp-1.png',
            alt: 'Person 1',
        },
    },
    {
        type: 'testimonial',
        variant: 'mobile-connected',
        testimonial: {
            quote: '"You don\'t have to figure out everything alone. With Udemy, I got everything I need, right where I need it."',
            author: {
                name: 'Cheyenne\nBrown',
                avatar: {
                    url: 'https://frontends.udemycdn.com/frontends-landing-pages/60-day-hustle/images/social-proof/G2_7.png',
                    alt: 'Cheyenne Brown',
                },
            },
        },
    },
    {
        type: 'avatars-only',
        variant: 'mobile',
        avatars: AVATAR_SETS.FULL_SET,
    },
    {
        type: 'video',
        variant: 'full',
        media: {
            url: '/60-day-hustle/videos/60-day-hustle-sp2-v2.mp4',
            alt: 'Video testimonial from Cheyenne Brown',
        },
        chipType: ChipType.MARKETING,
        chipTypeBottom: ChipType.SCALABILITY,
    },
    {
        type: 'media',
        variant: 'full',
        media: {
            url: 'https://frontends.udemycdn.com/frontends-landing-pages/60-day-hustle/images/social-proof/60-day-hustle-sp-2.png',
            alt: 'Person 2',
        },
    },
    {
        type: 'testimonial',
        variant: 'mobile-connected',
        testimonial: {
            quote: '"The experts on Udemy make it really easy to understand. They break it down really well and teach you a lot of things you can use to harness the power of AI."',
            author: {
                name: 'Joseph\nKemp',
                avatar: {
                    url: 'https://frontends.udemycdn.com/frontends-landing-pages/60-day-hustle/images/social-proof/G1_6.png',
                    alt: 'Joseph Kemp',
                },
            },
        },
    },
    {
        type: 'avatars-only',
        variant: 'mobile',
        avatars: [...AVATAR_SETS.PARTIAL_SET, ...AVATAR_SETS.PARTIAL_SET],
    },
    {
        type: 'video',
        variant: 'full',
        media: {
            url: '/60-day-hustle/videos/60-day-hustle-sp1-v2.mp4',
            alt: 'Video testimonial from Cheyenne Brown',
        },
        chipType: ChipType.HYPE_AND_PUBLICITY,
        chipTypeBottom: ChipType.SOFT_SKILLS,
    },
    {
        type: 'media',
        variant: 'full',
        media: {
            url: 'https://frontends.udemycdn.com/frontends-landing-pages/60-day-hustle/images/social-proof/60-day-hustle-sp-3.png',
            alt: 'Person 3',
        },
    },
    {
        type: 'testimonial',
        variant: 'mobile-connected',
        testimonial: {
            quote: '"Now when it comes to my business, I don\'t have to guess anymore. I know exactly where to go to access information."',
            author: {
                name: 'Cheyenne\nBrown',
                avatar: {
                    url: 'https://frontends.udemycdn.com/frontends-landing-pages/60-day-hustle/images/social-proof/G2_7.png',
                    alt: 'Cheyenne Brown',
                },
            },
        },
    },
];
